module.exports = __webpack_public_path__ + "img/numan.77a16e4f.jpg";